import React from "react";
import ForwardIcon from "../../../UI/IconComponents/ForwardIcon";
import Wrapper from "../../../UI/Wrapper/Wrapper";
import banner from "./images/banner.png";
import "./_Main.scss";

const TopSection = () => {
  return (
    <div className="ead__top-section">
      <img src={banner} alt="Eve After Dark" />
      <Wrapper bg_Color="#000000">
        <div className="ead__top-section-upper">
          <span>
            <h6 className="text-medium-semi font-semibold light-text">
              Overview
            </h6>
            <p className="text-small font-normal light-text">
              Awa Digital provides ordering and kitchen operations software for
              Eve After Dark, a cloud kitchen brand in Nigeria and the UK.
              Inventory, branches, and fulfilment are managed from a single admin
              across Lagos, Abuja, and London.
            </p>
          </span>
          <span>
            <h6 className="text-medium-semi font-semibold light-text">
              What we built
            </h6>
            <p className="text-small font-normal light-text">
              Customer ordering, branch and stock management, and operational
              workflows for multi-location cloud kitchen delivery.
            </p>
          </span>
          <div className="ead__top-section-btn">
            <a
              className="text-medium font-normal light-text"
              href="https://theeveafterdark.co.uk"
              target="_blank"
              rel="noreferrer"
            >
              Visit site{" "}
              <ForwardIcon
                size={30}
                fill="#DDDDDD"
                hoverColor="rgb(255, 0, 24)"
              />
            </a>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default TopSection;
